export const tenantConfigConnection: string[] = [
  "instanceName",
  "googleMapsKey",
  "emailVerificationEnabled",
];

export const RESTART_POLL_TIMEOUT = 2 * 60 * 1000;
export const RESTART_POLL_INTERVAL = 2000;
